import React from "react";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import MessageReadReceipt from "./MessageReadReceipt";
import { getNodeText } from "../utils/common";
import { canEditMessage } from "../utils/messageUtils";

function renderMessageWithLinks(text) {
  if (typeof text !== "string") return text;

  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.com[^\s]*)/gi;
  const matches = text.match(urlRegex);
  if (!matches) return text;

  const parts = [];
  let lastIndex = 0;

  text.replace(urlRegex, (url, index) => {
    if (index > lastIndex) {
      parts.push(text.substring(lastIndex, index));
    }

    if (url.includes("@")) {
      parts.push(url);
      lastIndex = index + url.length;
      return url;
    }

    let cleanUrl = url;
    let trailing = "";
    const trailingPunctuation = /[.,?!;)]+$/;
    const matchPunct = url.match(trailingPunctuation);
    if (matchPunct) {
      cleanUrl = url.substring(0, url.length - matchPunct[0].length);
      trailing = matchPunct[0];
    }

    const href = cleanUrl.toLowerCase().startsWith("http") ? cleanUrl : `https://${cleanUrl}`;
    parts.push(
      <a
        key={index}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "inherit", textDecoration: "underline", wordBreak: "break-all" }}
      >
        {cleanUrl}
      </a>
    );
    if (trailing) {
      parts.push(trailing);
    }

    lastIndex = index + url.length;
    return url;
  });

  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  return parts;
}

export default function MessageChatRow({
  message,
  loggedInUserId,
  formatDate,
  formatTime,
  onEdit,
}) {
  const mine =
    String(message?.sender_id) === String(loggedInUserId ?? "");
  const senderLabel =
    message?.sender_name ||
    (mine ? "You" : message?.sender_role || "User");
  const showEdit = canEditMessage(message, loggedInUserId);
  const body = getNodeText(message?.message) || message?.message || "";

  return (
    <div
      className={`message-row ${mine ? "mine" : "theirs"}`}
    >
      <div className={`message-item ${mine ? "mine" : "theirs"}`}>
        <div className={`message-bubble ${mine ? "mine" : "theirs"}`}>
          <div className="message-head">
            <span className="message-sender">{senderLabel}</span>
            <span className="message-text" style={{ whiteSpace: "pre-wrap" }}>
              {renderMessageWithLinks(body)}
              <span className="message-meta">
                {formatDate ? (
                  <span className="message-date">{formatDate(message)}</span>
                ) : null}
                {formatTime ? (
                  <span className="message-time">{formatTime(message)}</span>
                ) : null}
                {mine ? <MessageReadReceipt isRead={message?.is_read} /> : null}
                {showEdit && onEdit ? (
                  <IconButton
                    size="small"
                    className="message-edit-btn"
                    aria-label="Edit message"
                    title="Edit message"
                    onClick={() => onEdit(message)}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                ) : null}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
